// Module
var code = "<div id=\"queue-page\" data-cy=\"queue-page\"></div> ";
// Exports
module.exports = code;